import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Link } from 'react-router';
// CheckCircle 아이콘 import
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { CheckCircle } from 'lucide-react';
const SidebarContainer = styled.aside(({ theme })=>({
        // 너비는 부모 컴포넌트나 다른 곳에서 제어될 수 있으므로 유지하거나 필요시 제거
        // width: '300px',
        backgroundColor: `var(--my-card-background)`,
        height: '100%',
        overflowY: 'auto',
        borderLeft: `1px solid var(--theme-border)`
    }));
const Section = styled.div(({ theme })=>({
        borderBottom: `1px solid var(--theme-border)`
    }));
const SectionHeader = styled.div(({ theme })=>({
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        fontWeight: theme.typography.fontWeight.semibold,
        backgroundColor: `var(--theme-paper-light)`,
        color: `var(--theme-text-secondary)`,
        fontSize: theme.typography.fontSize.sm
    }));
const LectureList = styled.ul({
    listStyle: 'none',
    padding: 0,
    margin: 0
});
const LectureItem = styled.li(({ theme, isActive, isCompleted })=>({
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        borderTop: `1px solid var(--theme-border-light)`,
        fontSize: theme.typography.fontSize.sm,
        backgroundColor: isActive ? `var(--theme-paper-hover)` : 'transparent',
        fontWeight: isActive ? theme.typography.fontWeight.semibold : theme.typography.fontWeight.normal,
        color: isCompleted ? `var(--theme-text-muted)` : `var(--theme-text)`,
        opacity: isCompleted ? 0.8 : 1,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.sm,
        cursor: 'pointer',
        transition: `background-color ${theme.transition.fast}`,
        a: {
            textDecoration: 'none',
            color: 'inherit',
            display: 'block',
            flexGrow: 1,
            outline: 'none'
        },
        '&:hover': {
            backgroundColor: !isActive ? `var(--theme-paper-hover)` : undefined,
            opacity: 1
        },
        '.completed-icon': {
            color: `var(--theme-success)`,
            flexShrink: 0,
            width: '16px',
            height: '16px'
        }
    }));
const LectureSidebar = ({ courseId, curriculum, currentLectureId })=>{
    const theme = useTheme(); // 테마 객체 가져오기
    return /*#__PURE__*/ _jsx(SidebarContainer, {
        children: curriculum.map((section)=>/*#__PURE__*/ _jsxs(Section, {
                children: [
                    /*#__PURE__*/ _jsx(SectionHeader, {
                        children: section.title
                    }),
                    /*#__PURE__*/ _jsx(LectureList, {
                        children: Array.isArray(section.lectures) && section.lectures.map((lecture)=>{
                            const isActive = lecture.id === currentLectureId;
                            // isCompleted 값 확인 (lecture 타입이 LectureSummary로 변경되었으므로 접근 가능)
                            const isCompleted = lecture.isCompleted === true;
                            return(// LectureItem에 isCompleted prop 전달
                            /*#__PURE__*/ _jsxs(LectureItem, {
                                isActive: isActive,
                                isCompleted: isCompleted,
                                children: [
                                    isCompleted && /*#__PURE__*/ _jsx(CheckCircle, {
                                        className: "completed-icon",
                                        "aria-label": "완료됨"
                                    }),
                                    /*#__PURE__*/ _jsx(Link, {
                                        to: `/learn/course/${courseId}/lecture/${lecture.id}`,
                                        children: lecture.title
                                    })
                                ]
                            }, lecture.id));
                        })
                    })
                ]
            }, section.id))
    });
};
// Default export for backward compatibility
export default LectureSidebar;
